import { Button } from 'components/shared/Button.styled';
import { StyledFormGroupError } from 'components/shared/FormGroup.styled';
import { Heading1 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { getPublicPath as path } from 'utils/paths';
import {
  color,
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledHero = styled.section`
  background-image: url('${path('/images/sOLanding/hero-bg.svg')}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center bottom;
  padding-bottom: 5rem;

  @media (max-width: ${screen('lgMax')}) {
    background-image: url('${path('/images/sOLanding/hero-bg-mob.svg')}');
    background-position: left bottom;
    padding-bottom: 8rem;
  }
`;

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  display: flex;
  gap: ${spacing('xl')};
  padding-top: ${spacing('xl4')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};

  @media (max-width: ${screen('mdMax')}) {
    padding-top: ${spacing('xl')};
  }
`;

export const StyledContent = styled.div`
  flex-grow: 1;
  max-width: 42rem;
  margin: auto;
  color: ${color('text_default_inverse')};
  font-size: ${fontSize('lg')};
  line-height: 1.6;

  @media (max-width: ${screen('mdMax')}) {
    font-size: ${fontSize('md')};
  }

  @media (min-width: ${screen('lg')}) {
    margin: 0;
  }

  ${Heading1} {
    @media (max-width: ${screen('lgMax')}) {
      text-align: center;
    }
    span {
      display: inline-block;
    }
  }

  a {
    color: ${color('link_inverse')};

    &:hover {
      color: ${color('link_inverse_hover')};
    }

    &:active {
      color: ${color('link_inverse_active')};
    }
  }

  strong {
    font-weight: ${fontWeight('extraBold')};
  }
`;

export const StyledImage = styled.div`
  flex-shrink: 0;
  max-width: 18.5rem;
  margin-left: auto;

  @media (max-width: ${screen('lgMax')}) {
    display: none;
  }
`;

export const StyledMobileImage = styled.div`
  max-width: 11rem;
  margin: auto;

  @media (min-width: ${screen('lg')}) {
    display: none;
  }

  img {
    display: block;
  }
`;

export const StyledLead = styled.p`
  font-size: ${fontSize('xl2')};
  line-height: 1.14;
  font-weight: ${fontWeight('black')};

  @media (max-width: ${screen('lgMax')}) {
    font-size: ${fontSize('lg')};
    text-align: center;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  align-items: flex-end;
  gap: ${spacing('md')};
  margin-bottom: ${spacing('lg')};

  @media (max-width: ${screen('mdMax')}) {
    flex-direction: column;
    align-items: flex-start;
  }

  ${Button} {
    flex-shrink: 0;
    min-height: 3.5rem;
  }

  ${StyledFormGroupError} {
    @media (min-width: ${screen('md')}) {
      position: absolute;
    }
  }
`;
